export default __webpack_public_path__ + "static/media/UncleSamTry.7f402616.png";